export default {
    dashboard: 'داشبورد',
    profile: 'پروفایل',
    home: 'خانه',
    users: 'کاربرها',
    doctors: 'پزشکان',
    doctor: 'پزشک',
    patients: 'بیمارها',
    patient: 'بیمار',
    admission: 'پذیرش',
    edit: 'ویرایش',
    detailsAndEdit: 'جزيیات و ویرایش',
    female: 'خانم',
    male: 'آقا',
    userSettings: 'تنظیمات کاربر',
    persian:'فارسی',
    english:'انگلیسی',
    arabic:'عربی',
    available:'در دسترس',
    login:'ورود کاربر',
    logout:'خروج از سیستم',
    welcomeLogin:'خوش آمدید ، لطفاً به حساب خود وارد شوید.',
    welcomeDear:'عزیز خوش آمدید',
    username:'نام کاربری',
    password:'رمز عبور',
    loginButton: 'ورود به سیستم',
    submit: 'ثبت',
    submitEdition: 'ثبت ویرایش',
    add: 'افزودن',
    delete: 'حذف',
    deactivate:'غیر فعال',
    active:'فعال',
    inactive:'غیر فعال',
    disable: 'غیر فعال',
    status: 'وضعیت',
    search: 'جستجو',
    searchByName: 'جستجو بر اساس نام',
    pageLength: 'نمایش',
    of: 'مورد از ',
    pageText2: 'مورد کل',
    action: 'عملیات',
    percent: 'درصد',
    amount: 'مبلغ',
    tax: 'مالیات',
    yes: 'بله',
    no: 'خیر',
    date: 'تاریخ',
    fromDate: 'از تاریخ',
    toDate: 'تا تاریخ',
    name: 'نام',
    from: ' از ',
    to: ' تا ',
    to1: ' به ',
    result: ' نتیجه ',
    positive: ' مثبت ',
    negative: ' منفی',
    genderDetermination: 'تعیین جنسیت',
    gender_determination: 'تعیین جنسیت',
    forDisease: 'برای بیماری',
    for_disease: 'برای بیماری',
    description: 'توضیحات',
    filters: 'فیلترها',
    year: ' سال ',
    month: 'ماه ',
    day: 'روز',
    and:' و ',
    registerAndNew:' ثبت و جدید ',
    welcomeHomePage:'به سیستم مدیریت مرکز مام خوش آمدید.',
    titleHomePage:'سیستم ثبت و نوبت دهی بیماران مرکز مام',
    confirmDelete:'آیا از حذف این مورد/موارد اطمینان دارید؟',
    confirmDeleteHoliday:'آیا از حذف این تعطیلی اطمینان دارید؟',
    confirmDeleteRequest:'آیا از ارسال درخواست حذف این مورد/موارد اطمینان دارید؟',
    confirmDeleteTitle:'تایید حذف',
    confirmDeleteRequestTitle:'تایید/رد درخواست حذف',
    confirmSendToCashierTitle:'تایید ارسال به کارتابل',
    confirmSendToCashier:'آیا از این مورد اطمینان دارید؟',
    confirmSendToQueueTitle:'ارسال به صف',
    confirmSendToQueue:'آیا از این مورد اطمینان دارید؟',
    confirmPayment:'در صورت تایید پرداخت، امکان بازگردانی وجود ندارد؟',
    confirmPaymentTitle:'تایید پرداخت',
    confirmMove: 'آیا از انتقال نوبت اطمینان دارید ؟ ',
    confirmMoveTitle:'تایید انتقال',
    confirmMoveRequestTitle:'تایید/رد درخواست انتقال',
    new : 'جدید',
    select: 'انتخاب',
    role: 'نقش',
    submitAndReferral: 'ذخیره و ایجاد مراجعه',
    editAndReferral: 'ویرایش و ایجاد مراجعه',
    girl: 'دختر',
    boy: 'پسر',
    noMatter: 'دختر-پسر',
    no_matter: 'دختر-پسر',
    internal: 'داخلی',
    external: 'بیرونی',
    type: 'نوع',
    pos: 'پوز',
    cash: 'نقدی',
    pleaseSelect: 'لطفا انتخاب کنید',
    hospital: 'مرکز',
    both: 'هر دو',
    bankCard: 'کارت  بانکی',
    recommendation: 'توصیه/پیشنهاد',
    selectFile: 'انتخاب فایل',
    image: 'تصویر',
    changeImage: 'تغییر تصویر',
    back: 'بازگشت',
    present: 'حاضر',
    absent: 'غایب',
    daily: 'روزانه',
    weekly: 'هفتگی',
    monthly: 'ماهانه',
    one_way: 'یک طرفه',
    two_way: 'دو طرفه',
    right: 'راست',
    left: 'چپ',
    title:'عنوان',
    approved:'تایید',
    approveAndDelete:'تایید و حذف',
    rejected:'رد',
    conditional:'مشروط',
    documentTitle:'عنوان مدرک',
    read:'خواندم',
    isRead:'خوانده شد',
    legalVisitTypes:{
        donated_sperm: "اسپرم اهدایی" ,
        donated_embryo: " جنین اهدایی" ,
        donated_egg: "تخمک اهدایی" ,
        surrogate_uterus: "رحم جایگزین" ,
        egg_freeze: "فریز تخمک" ,
        other: "سایر" ,
        ivf: "IVF ساده" ,
    },
    has:'دارد',
    doesNotHave: 'ندارد',
    donationClinicAccount:"حساب کلینیک اهداء",
    ipdAccount:"حساب IPD",
    addRecord:"افزودن مورد جدید",
    print: "چاپ",
    isDefault: "حالت پیش فرض",
    fromMedicalRecord  : ' ارجاع دهنده',
    toMedicalRecord  : ' ارجاع گیرنده',
    cashImprestFunds : "تنخواه گردان صندوق",
    bankOfCompany : "بانک شرکت(نقدی)",
    cancel : "انصراف",
    ok : "ثبت",
    uploadedFiles : "فایلهای آپلود شده",
    size : "اندازه",
    kb : "کیلوبایت",
    acceptableFiles : 'فایلهای مورد پذیرش: {items}',
    close : 'بستن',
    itemNotExist : 'موردی جهت نمایش ثبت نشده است',
    visit : 'ویزیت',
    addVisit : 'افزودن ویزیت',
    relatedTo: 'مربوط به',
    row: 'ردیف',
    gregorian: 'میلادی',
    Solar: 'شمسی',
    inDate: 'در تاریخ',
    all: 'همه',
    pending: 'در حال بررسی',
    deleteRequestMsg : 'درخواست حذف این پذیرش توسط {fullName} ارسال گردیده است؛ آیا مایل به حذف این مورد هستید؟',
    deleteRequestWarning:'در صورت تایید، امکان بازگردانی وجود ندارد!',
    queue : 'صف انتظار',
    done : 'انجام شده',
    registerAbsent : 'ثبت عدم حضور دکتر',
    throughoutTheDay : 'عدم حضور در طول این تاریخ',
    startDate : 'تاریخ شروع',
    endDate : 'تاریخ پایان',
    startTime : 'ساعت شروع',
    endTime : 'ساعت پایان',
    durationOfQueue : 'بازه زمانی هر نوبت',
    days : 'روزها',
    countOfQueue : 'تعداد افراد در هر نوبت',
    planOfDoctor: 'برنامه کاری پزشک',
    unitOfPlan:'واحد'
}
